var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-card md-card-pricing",class:_vm.cardClass},[_vm._t("category"),_c('div',{staticClass:"md-card-content"},[_c('div',{staticClass:"md-card-icon",class:_vm.iconColor},[_vm._t("icon")],2),_vm._t("title"),_vm._t("description")],2),_c('div',{staticClass:"md-card-actions text-center"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }